import { Navigate, useParams } from 'react-router';
import { useSecodaEntity } from '../../api/hooks/secodaEntity/useSecodaEntity';
import { buildResourceUrl } from '../../utils/navigationUtils';
import { LoadingSpinner } from '../LoadingSpinner';

export function ResourceRedirect() {
	const { id } = useParams<{ id: string }>();

	const {
		data: entity,
		isLoading,
		error,
	} = useSecodaEntity({
		id: id as string,
		options: { enabled: Boolean(id) },
	});

	if (isLoading) return <LoadingSpinner />;
	if (error || !entity) return <Navigate to="/404" replace />;

	const correctUrl = buildResourceUrl({
		id: entity.id,
		entity_type: entity.entity_type,
	});

	// Unknown entity type or invalid URL
	if (correctUrl === '#') {
		return <Navigate to="/404" replace />;
	}

	return <Navigate to={correctUrl} replace />;
}
